import { call, put, takeLatest, takeLeading } from 'typed-redux-saga'
import { RoleModel } from 'Models'
import { FunctionAliasModel } from 'Pages/pp/matrixRole'
import { matrixRoleApi, matrixRoleSlice, MatrixRoleNS } from 'Pages/pp'
import { errorHandler, loadersSlice, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'

function* updateOne(action: MatrixRoleNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { role_id, function_ids } = action.payload
		yield* call(matrixRoleApi.updateOne, role_id, function_ids)
		const res = yield* call(matrixRoleApi.getOne, role_id)
		yield* put(matrixRoleSlice.actions.setOne(Deserialize(res, RoleModel)))
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'common.role_update.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getOne(action: MatrixRoleNS.GetOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(matrixRoleApi.getOne, action.payload)
		yield* put(matrixRoleSlice.actions.setOne(Deserialize(res, RoleModel)))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}
function* getItems() {
	try {
		const res = yield* call(matrixRoleApi.getFunctions)
		const functions = res.map((func): FunctionAliasModel => Deserialize(func, FunctionAliasModel))
		yield* put(matrixRoleSlice.actions.setItems(functions))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const matrixRoleSaga = function* saga() {
	yield* takeLatest(matrixRoleSlice.actions.updateOne, updateOne)
	yield* takeLatest(matrixRoleSlice.actions.getOne, getOne)
	yield* takeLeading(matrixRoleSlice.actions.getItems, getItems)
}
